import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_RATA_INCARICO } from '../../data.const';
import {
  retrieveRataIncaricoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteRataIncaricoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_RATA_INCARICO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_RATA_INCARICO}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        defer(() =>
          from(
            request({ path: `rataIncarico`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_RATA_INCARICO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveRataIncaricoListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_RATA_INCARICO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default deleteRataIncaricoEpic;
